import styles from './KPIBodyConfig.module.scss'
import { useCallback, useEffect, useState } from 'react'
import { KPI_DEFAULT_VALUES } from '../../styleConsts'
import { ScoopSlider } from '../../../../../../ui'
import { propExistsOnObject } from '../../utils'
import { debounce, cloneDeep } from 'lodash'

export const KPIBodyConfig = ({ kpiProp, config, setConfig, chartPreferences }) => {
    const [borderRadius, setBorderRadius] = useState(KPI_DEFAULT_VALUES.body.borderRadius)
    const [padding, setPadding] = useState(KPI_DEFAULT_VALUES.body.padding)

    useEffect(() => {
        setBorderRadius(getKPIPropValue('borderRadius'))
        setPadding(getKPIPropValue('padding'))
    }, [config])

    const debouncedFunc = useCallback(
        debounce((prop, value) => {
            const newConfig = cloneDeep(config)
            newConfig.styleOverrides.kpi.body[prop] = value
            setConfig(newConfig)
        }, 200),
        [config, kpiProp]
    )

    const getKPIPropValue = (prop) => {
        if (propExistsOnObject(config.styleOverrides.kpi.body, prop))
            return config.styleOverrides.kpi.body[prop]
        if (chartPreferences.kpi && propExistsOnObject(chartPreferences.kpi.body, prop))
            return chartPreferences.kpi.body[prop]
        return KPI_DEFAULT_VALUES.body[prop]
    }

    const handleDebounceKPIPropChange = (prop, value, setter) => {
        debouncedFunc(prop, value)
        setter(value)
    }

    return (
        <div className={styles.container}>
            <ScoopSlider
                label={`Border radius: ${borderRadius}px`}
                value={borderRadius}
                min={0}
                max={50}
                step={1}
                onChange={(v) => handleDebounceKPIPropChange('borderRadius', v, setBorderRadius)}
            />
            <ScoopSlider
                label={`Margin: ${padding}px`}
                value={padding}
                min={0}
                max={50}
                step={1}
                onChange={(v) => handleDebounceKPIPropChange('padding', v, setPadding)}
            />
        </div>
    )
}
